<template>
  <div id="app" class="container-fluid" :class="{ no_auth: !$store.state.isLoggedIn }">
    <loading />
    <myHeader />
    <mainNavBar />
    <div id="main" class="mt-2">
      <router-view />
    </div>
    <modalConsigneeList />
    <modalCarrierList />
    <appReload/>
  </div>
</template>

<script>
import appReload from '@/components/mixins/checkApiVersion.vue';
import myHeader from "@/pages/Header.vue";
import mainNavBar from "@/components/navigation/MainNavBar.vue";
import modalConsigneeList from "@/components/portal/customer/ModalConsigneeList";
import modalCarrierList from "@/components/portal/carrier/ModalCarrierList";
import loading from "@/components/portal/global/loading";
export default {
  components: {
    appReload,
    loading,
    myHeader,
    mainNavBar,
    modalConsigneeList,
    modalCarrierList,
  },
};
</script>
